import Dexie, { type EntityTable } from 'dexie'
import type {
  AppSettingRecord,
  CategoryRecord,
  ImageBinaryRecord,
  ImageMetaRecord,
  ImageSearchRecord
} from '../types/catalog'

class CatalogDatabase extends Dexie {
  categories!: EntityTable<CategoryRecord, 'id'>
  images!: EntityTable<ImageMetaRecord, 'id'>
  imageFiles!: EntityTable<ImageBinaryRecord, 'id'>
  imageSearch!: EntityTable<ImageSearchRecord, 'key'>
  settings!: EntityTable<AppSettingRecord, 'key'>

  constructor() {
    super('photo-vault-db')

    this.version(1).stores({
      categories: '&id, parentId, [parentId+name], *ancestorIds, createdAt, updatedAt',
      images: '&id, categoryId, [categoryId+updatedAt+id], [updatedAt+id], *categoryAncestors, *tokens, updatedAt',
      imageFiles: '&id',
      imageSearch: '&key, token, imageId, categoryId, [token+updatedAt+imageId], [token+categoryId+updatedAt+imageId], *categoryAncestors',
      settings: '&key'
    })

    this.version(2).stores({
      categories: '&id, name, parentId, [parentId+name], *ancestorIds, createdAt, updatedAt',
      images: '&id, categoryId, [categoryId+updatedAt+id], [updatedAt+id], *categoryAncestors, *tokens, updatedAt',
      imageFiles: '&id',
      imageSearch: '&key, token, imageId, categoryId, [token+updatedAt+imageId], [token+categoryId+updatedAt+imageId], *categoryAncestors',
      settings: '&key'
    })
  }
}

export const db = new CatalogDatabase()

export async function ensureInitialCategory(): Promise<CategoryRecord> {
  const existing = await db.categories.orderBy('createdAt').first()
  if (existing) return existing

  const now = Date.now()
  const inbox: CategoryRecord = {
    id: crypto.randomUUID(),
    name: 'Inbox',
    parentId: null,
    ancestorIds: [],
    depth: 0,
    directImageCount: 0,
    createdAt: now,
    updatedAt: now
  }
  await db.categories.add(inbox)
  return inbox
}
